import type { PredictedAgeGroup } from '@volt/shared';

export interface AgeClassifierInput {
  avgInteractionMs: number | null;
  medianInteractionMs: number | null;
  stdInteractionMs: number | null;
  maxScrollDepthPct: number;
  scrollSpeedPxPerSec: number | null;
  rageClicks: number;
  eventsPerMinute: number;
  avgNavigationTimeMs: number | null;
  aiRequestsSent: number;
  searchesCount: number;
}

export function classifyAgeGroup(input: AgeClassifierInput): PredictedAgeGroup {
  const speed = input.medianInteractionMs ?? input.avgInteractionMs ?? Infinity;
  const scrollSpeed = input.scrollSpeedPxPerSec ?? 0;
  const navigation = input.avgNavigationTimeMs ?? 0;
  const engagement = input.aiRequestsSent + input.searchesCount;

  if (speed === Infinity) return 'unknown';
  if (speed < 320 && input.eventsPerMinute > 30 && input.rageClicks >= 2) return 'child';
  if (speed < 450 && scrollSpeed > 2200 && input.maxScrollDepthPct > 70) return 'teen';
  if (speed < 900 && input.eventsPerMinute > 12 && engagement >= 2) return 'young_adult';
  if (speed < 1800 && navigation > 0 && navigation < 20_000) return 'adult';
  if (speed >= 1800 || (input.stdInteractionMs ?? 0) > 2500) return 'senior';
  return 'unknown';
}
